import { createFileRoute } from "@tanstack/react-router";
import { ConfigurationHome } from "@/pages/3d/configuration/ConfigurationHome";

export const Route = createFileRoute("/demo/3d/configuration/")({
  component: ConfigurationHome,
});
